// import { unit } from '@lib/style/unit';

export const updateGoSquaredPosition = (_bottom: any) => {
    //     let styleElement = document.querySelector('#hubspot-style');
    //     if ( !styleElement ) {
    //         styleElement = document.createElement('style');
    //         styleElement.id = 'hubspot-style';
    //         document.head.appendChild(styleElement);
    //     }
    //
    //     styleElement.innerHTML = `body div#hubspot-messages-iframe-container.widget-align-right {
    //     transition: bottom 200ms;
    //     bottom: ${ unit(bottom + 30) } !important;
    // }`;
};
